import React from 'react';
import { useField, UseFieldConfig } from 'react-final-form';
import { Select } from '../Select/Select';

type SelectFieldProps<ValueType> = Omit<
  React.ComponentProps<typeof Select>,
  'value' | 'onChange' | 'error' | 'errorText'
> & {
  initialValue?: ValueType;
  validate?: UseFieldConfig<ValueType>['validate'];
  onChange?: (value: ValueType) => void;
  forceShowErrors?: boolean;
};

export const SelectField = <ValueType extends string = string>({
  name,
  validate,
  initialValue,
  onChange,
  forceShowErrors,
  ...rest
}: SelectFieldProps<ValueType>) => {
  const { input, meta } = useField<ValueType>(name, { validate, initialValue });
  const hasError =
    !!meta.error && (forceShowErrors || meta.touched || meta.modified);
  return (
    <Select
      {...rest}
      error={hasError}
      errorText={hasError ? meta.error : undefined}
      name={name}
      onChange={(event) => {
        input.onChange(event);
        onChange?.(event.target.value as ValueType);
      }}
      value={input.value}
    />
  );
};
